import { Component, OnInit } from '@angular/core';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import { DoctorsService } from '../shared/doctor-service/doctors.service';
import { AuthService } from '../auth-section/auth-service/auth.service';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-refrence',
  templateUrl: './refrence.component.html',
  styleUrls: ['./refrence.component.css']
})
export class RefrenceComponent implements OnInit {
  refform: FormGroup;
  editform: FormGroup;
  userToken:string;
  id:string;
  hospitalId:any;
  showdata:any;
  doctype:any;

  constructor( private doctorservice:DoctorsService, private authservice:AuthService) { }

  ngOnInit(): void {
    this.refform = new FormGroup({
      hospitalId: new FormControl(this.hospitalId),
      phoneNo: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      percent: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      name: new FormControl(null,Validators.required),
      email: new FormControl(null,Validators.required)
    })
    this.editform = new FormGroup({
      hospitalId: new FormControl(this.hospitalId),
      phoneNo: new FormControl(null,[
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
      ]),
      name: new FormControl(null,Validators.required),
      email: new FormControl(null,Validators.required)
    })    
    this.authservice.authDataSubject.pipe(take(1)).subscribe(authData => {
      this.userToken = authData._token;
      this.id = authData._id;
      this.doctype = authData._type;
      console.log(this.id);
    });
    this.single();
  }

  Bookrefrence(){
    console.log("this is formvalue" , this.refform.value);
    this.doctorservice.Refrence(this.refform.value,this.userToken).subscribe((res:any)=>{
      console.log( "this is refer",res);
    })
  }
  Getrefrence(){
    this.doctorservice.GetRefrence(this.hospitalId,this.userToken).subscribe((res:any)=>{
      console.log(res,"this refdata")
      this.showdata = res.data;
    },(err)=>{
      if(err.message="No Data available"){
      }
    })
  }
  deletRefrence(_id){
console.log("this is", _id);
  }
  EditRefrence(){
    console.log("this is editform" , this.editform.value);
    this.doctorservice.EditRefrence(this.editform,this.userToken).subscribe((res:any)=>{
      console.log("this is Edit Form", res)
    })
  }

  single(){
    this.doctorservice.getSinglereceptionist(this.id, this.userToken).subscribe((res:any)=>{
      console.log( "this is id" , res);
      if(this.doctype == "DOCTOR"){
      }
      this.hospitalId = res.clinicId[0].hospitalId._id;
      console.log("this is identfy" , this.hospitalId);
      this.Getrefrence();
      this.refform = new FormGroup({
        hospitalId: new FormControl(this.hospitalId),
        phoneNo: new FormControl(null,[
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
        ]),
        percent: new FormControl(null,[
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.required
        ]),
        name: new FormControl(null,Validators.required),
        email: new FormControl(null,Validators.required)
      })
    });
  }
  
}
